import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Modal, Button, Form, Select, Spin } from 'antd';
import { SaveOutlined } from '@ant-design/icons';

import { renderNoDataOrSpinner } from '../../../shared/utils';

import { AppDispatch, RootState } from '../../../store';

import * as actions from '../store/actions';

type ReAssignModalProps = {
  noteId: string | number;
  visible: boolean;
  close: (refreshData?: boolean) => void;
}

const ReAssignModal: React.FC<ReAssignModalProps> = ({ noteId, visible, close }) => {
  const dispatch = useDispatch<AppDispatch>();

  const [reassignForm] = Form.useForm<any>();

  const { truckingCompanies, truckingCompaniesLoading, reassignNoteLoading } = useSelector((state: RootState) => state.notes);

  useEffect(() => {
    dispatch(actions.getAllTruckingCompanies() as any);
  }, []);

  const handleSave = (): void => {
    reassignForm.validateFields().then((values: any) => {
      const formData = values;
      formData.noteId = noteId;

      dispatch(actions.reassignNote(formData) as any).then(() => {
        close(true);
      });
    });
  };

  const handleClose = (): void => {
    reassignForm.resetFields();
    close(false);
  };

  return (
    <Modal
      title="Link to Insured"
      centered
      open={visible}
      onOk={() => handleSave}
      onCancel={() => handleClose()}
      width={700}
      maskClosable={false}
      confirmLoading={reassignNoteLoading}
      okButtonProps={{ disabled: reassignNoteLoading }}
      footer={[
        <Button key="back" onClick={handleClose}>
          Close
        </Button>,
        <Button
          key="button"
          type="primary"
          ghost
          htmlType="button"
          icon={<SaveOutlined />}
          onClick={handleSave}
          loading={reassignNoteLoading}
          disabled={reassignNoteLoading}
        >
          Save
        </Button>,
      ]}
    >
      <Form id="re-assign-note-modal" form={reassignForm} style={{ width: '100%' }} layout="vertical">
        <Form.Item label="Contact" name={['truckingCompanyId']} rules={[{ required: true, message: 'This field is required.' }]}>
          <Select
            getPopupContainer={() => document.getElementById('re-assign-note-modal') as HTMLElement}
            placeholder="Insured, Prospect, Carrier, MGA, Finance Company"
            loading={truckingCompaniesLoading}
            notFoundContent={renderNoDataOrSpinner(truckingCompaniesLoading)}
          >
            {truckingCompanies && truckingCompanies.length
              ? truckingCompanies.map((truckingCompany) => (
                <Select.Option value={truckingCompany.id} key={truckingCompany.id}>
                  {truckingCompany.name}
                </Select.Option>
              ))
              : null}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ReAssignModal;
